import React from 'react';
import { Button } from './ui/Button';
import { ShoppingCartIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white border-t border-gray-200 pb-12 pt-8 px-4" data-id="element-48">
      <div className="max-w-md mx-auto text-center sticky bottom-4 z-50" data-id="element-49">
        
      </div>

      <div className="text-center mt-8 text-gray-400 text-xs" data-id="element-50">
        <p data-id="element-51">© 2024 Tienda de Sueños. Todos los derechos reservados.</p>
        <p className="mt-2" data-id="element-52">Envíos a toda Argentina.</p>
      </div>
    </footer>;
}